<template>
  <div class="survey-container">
    <NavBarSurvey v-on:collapse = "none" :lastSaved="lastSaved"></NavBarSurvey>
    <v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
      <v-avatar
        slot="icon"
        color="deep-orange accent-4"
        size="40">
        <v-icon color="white">
        people_alt
        </v-icon>
      </v-avatar>
      You are viewing the survey of <strong>{{officeDescription}}</strong>.
      <template v-slot:actions>
        <v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
      </template>
    </v-banner>

    <v-layout style="border: 0px solid; margin-left:0px; padding-left: 100px; position: relative;">
        <div style="z-index: 1;margin-top:15px;">
          <scrollactive
            class="nav-menu"
            active-class="active"
            :offset="70"
            :duration="250"
            bezier-easing-value="0,0,.35,1"
            highlightFirstItem: true>
            <div class="content-header">Navigation</div>
            <v-layout class="section-reference" v-for="(intros,i) in items" :key="'Intro'+i">
              <a v-if="i === 0" class="scrollactive-item" :href="'#I'+i" :v-model="panel" @click="onInfoPanelClicked(i)">What&apos;s New</a>
              <a v-else-if="i === 1" class="scrollactive-item" :href="'#I'+i" :v-model="panel" @click="onInfoPanelClicked(i)">Information</a>
            </v-layout>
            <side-bar-question-link
              class="left-aligned scrollactive-item-container"
              :class="{active: q===selectedPanelId}"
              v-for="(question,q) in questions"
              :key="'Question'+q"
              :panel="questionPanel"
              :index="q"
              :question="question"
              :is-disabled="q>4 && !isRequiredQuestionComplete"
              @side-nav-question-clicked="onNavPanelClickedEx"
            ></side-bar-question-link>
          </scrollactive>
        </div>

      <v-flex style="z-index: 2;background-color:white; margin-top:15px;" xs12>
        <!-- SURVEY INFORMATION accordions -->
        <div class="group-header text-left mt-2">Survey Information</div>
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel v-for="(item,i) in items" :key="i">
            <a :id="'I'+i"></a>
            <v-expansion-panel-header id="scroll" class="accordion-container title type-reference" :class="'info'+i"  expand-icon="fa fa-chevron-down grey--text text--darken-3">
              <v-img v-if="i === 0" class="info-img-whatsnew" contain :src="require('../assets/whatsnew.png')"></v-img>
              <v-img v-if="i != 0" class="info-img" contain :src="require('../assets/materials.png')"></v-img>
              <span>{{ heading[i] }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="type-reference">
              <v-container v-if="isStandardSurvey()" fluid grid-list-md>
                <v-layout xs12>
                  <v-flex v-if="i === 0">
                    <wes-i1></wes-i1>
                  </v-flex>
                  <v-flex v-if="i === 1">
                    <wes-i3></wes-i3>
                  </v-flex>
                  <v-flex v-if="i === 2">
                    <wes-i4></wes-i4>
                  </v-flex>
                  <v-flex v-if="i === 3">
                    <wes-i5></wes-i5>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container v-else-if="!isStandardSurvey()" fluid grid-list-md>
                <v-layout xs12>
                  <v-flex v-if="i === 0">
                    <wes-DOD-i1></wes-DOD-i1>
                  </v-flex>
                  <v-flex v-if="i === 1">
										<wes-DOD-i3></wes-DOD-i3>
                  </v-flex>
                  <v-flex v-if="i === 2">
										<wes-DOD-i4></wes-DOD-i4>
                  </v-flex>
                  <v-flex v-if="i === 3">
                    <wes-DOD-i5></wes-DOD-i5>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container v-else>
                <v-layout xs12>
                  <v-flex>
                    SURVEY INFORMATION not available at this time.
                  </v-flex>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div v-if="true === isLoading" style="width: 98%;margin: 0 auto;height: 500px;border: 2px solid;border-radius: 5px;">
          <h1>Loading survey...</h1>
        </div>

        <div v-else>

          <!-- SURVEY QUESTIONS accordions -->
          <div class="group-header text-left mt-2">Survey Questions {{FYVolume}} <span style="text-align:right;color:red">(Note: The system works best if you open questions in sequential order. After that, answer in any order. If a question loads too slowly, please click 'Home' to refresh the screen).</span></div>
          <v-expansion-panels v-model="questionPanel" multiple>
            <v-expansion-panel v-for="(question,j) in questions" :key="j"
            :class="{'v-expansion-panel--disabled': j>4 && !isRequiredQuestionComplete}"
            @click="onClicked(j)">
             <a :id="'Q'+(j+1)"></a>
              <v-expansion-panel-header id="beginSurveyContent" class="accordion-container title" expand-icon="fa fa-chevron-down grey--text text--darken-3">
                <wes-question-number v-bind:index="question.displayId"></wes-question-number>
                <span>
                  {{ questions[j].label }}
                </span>
                <question-status-icon :questionId="question.id" class="mr-3"></question-status-icon>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid grid-list-md>
                  <v-layout>
                    <wes-question-container v-bind:question="question" :isStandardSurvey="isStandardSurvey()" @update-status="onUpdateAnswerStatus"></wes-question-container>
                  </v-layout>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <Footer></Footer>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { authTokenService } from '@/services/authTokenService.js';
import { surveyService } from '@/services/surveyService';
import { utilityService } from '@/services/utilityService';
import { configService } from '@/services/configService'
import { officeManagementService } from "@/services/officeManagementService.js";
import { CONSTANTS } from '@/common/constants'
import router from "@/router";

export default {
  name: 'Survey',
  props: {
    questions: Array,
    previousComponentName: String
  },
  data: () => ({
    activeId: Number,
    surveyType: Number,
    isLoading: true,
    currentAnswer: {},
    hasWhatsNewBeenViewed: false,
    hasGeneralDefinitionsBeenViewed: false,
    isWhatsNewExpanded: true,
    isGeneralInstructionsExpanded: false,
    panel: [],
    questionPanel: [],
    items: 4,
    selectedPanelId: null,
    heading: [
      'What’s New',
      'General Survey Definitions and Instructions',
      'Types of Funding to Include',
			'How Should I Report My Data?'
    ],
    show: false,
		status: [],
    lastSaved: null,
		interval: '',
		claims: {},
		impersonation: false,
		officeDescription: '',
		officeId: Number,
		completeStatuses: [ CONSTANTS.QUESTION_STATUS.WARNINGS, CONSTANTS.QUESTION_STATUS.COMPLETE ],
    nonAdmin: "false",
    FYVolume:null,
  }),
  mounted () {
    debugger;
    const me = this;
    me.FYVolume = authTokenService.getFYVolume();
    me.activeId = authTokenService.getActiveSurveyId();
		me.claims = authTokenService.getClaims();
    if(me.claims.userName == "Admin")
    {
      authTokenService.setNotaAdmin(false);
    }
    me.nonAdmin = authTokenService.getNotaAdmin();
    if(me.nonAdmin != "true") //means in case of admin
    {
      if (me.claims.role != undefined && me.claims.role.includes('Admin')) {
        me.impersonation = true;
      } else if (me.claims.surveyId != undefined && typeof me.claims.surveyId === 'string') {
        me.impersonation = me.claims.surveyId !== me.activeId;
      } else if (me.claims.surveyId != undefined && typeof me.claims.surveyId === 'object') {
        me.impersonation = !me.claims.surveyId.includes(me.activeId);
      }
    }

		officeManagementService.getOfficeBySurveyId(me.activeId).then(function (response) {
			if (response && response.data) {
				me.officeDescription = response.data.description;
				me.officeId = response.data.id;
			}
		});

    surveyService.getSurveyType(me.activeId).then(function (response) {
			if (response && response.data) {
        me.surveyType = response.data;
        return me.surveyType;
      }
		})
		.catch(function (e) {
			console.log(e);
			console.log('Error loading survey type in Intro section')
			throw e;
    });

    surveyService.getSurvey(me.activeId).then(function (response) {
			if (response && response.data) {
        me.surveyRoot = response.data;
      }
		})
		.catch(function (e) {
			console.log(e);
			console.log('Error loading survey')
			throw e;
    });
		me.initAutoSave();
	},
	beforeDestroy () {
		clearInterval(this.interval)
	},
	created: function () {
	},
  computed: {
    isRequiredQuestionComplete: function () {
			// DD - NOTE: should we move the question id\number to config or constants file
			if (this.$store.getters['validation/mandatoryQuestionsAnswered']() === true)
      {
				return true;
			}
      else if (this.$store.getters['validation/isQuestionComplete'](1) &&
				this.$store.getters['validation/isQuestionComplete'](2) &&
				this.$store.getters['validation/isQuestionComplete'](3) &&
				this.$store.getters['validation/isQuestionComplete'](4) &&
				this.$store.getters['validation/isQuestionComplete'](5) &&
				this.completeStatuses.includes(this.$store.getters['validation/questionStatus'](3)) &&
				this.completeStatuses.includes(this.$store.getters['validation/questionStatus'](5)))
        {
					this.$store.dispatch('validation/saveMandatoryQuestionsAnswered', true);
					return true;
			}
			return false;
    }
  },
  watch: {
    // whenever question changes, this function will run
    questions: function (newQuestions, oldQuestions) {
      if (// (!oldQuestions && newQuestions) || oldQuestions.length < newQuestions.length
        (newQuestions && newQuestions.length > 0))
      {
        this.isLoading = false;
      }
    },
    previousComponentName: function (newVal, oldVal) {
      if (newVal) console.log('Previous component name: ' + newVal);
    }
  },
  methods: {
    log (test) {
      console.log('log test = ' + test);
      console.log('log test[0] = ' + test[0]);
      console.log('log object = ' + JSON.stringify(test))
    },
		exit () {
      let name = this.previousComponentName;
      let params = {};
      if (name === 'details')
      {
        params = { id: this.officeId, surveyId: this.activeId };
        router.push({ name: name, params: params });
      }
      else
        router.push({ name: 'admin.stats' });
    },

		/**
		 * Initializes the auto save based on environment variables.
		 */
		initAutoSave: function () {
			if (configService.enable_autosave === true) {
				let me = this;
				me.interval = setInterval(function () {
					me.$store.dispatch('autoSaveAll');
				}, configService.autosave_interval);
			}
    },
    onPanelClicked: function (id) {
      debugger;
      if (id === 'i0')
      {
        this.isWhatsNewExpanded = !this.isWhatsNewExpanded;
      }
      else
      {
        this.isGeneralInstructionsExpanded = !this.isGeneralInstructionsExpanded;
      }
    },
    onInfoPanelClicked: function (id) {
      var checkI0 = 0;
      var checkI1 = 0;
      for (var i = 0; i < this.panel.length; i++)
      {
        if (this.panel[i] === 0)
        {
          checkI0++;
        }
        else if (this.panel[i] === 1)
        {
          checkI1++;
        }
      };
      if (id === 0 && checkI0 === 0)
      {
        this.panel.push(0);
      }
      else if (id === 1 && checkI1 === 0)
      {
        this.panel.push(1);
      };
    },
    onClick: function (evt) {
      debugger;
        const e = evt;
    },
    onClicked (j) {
      debugger;
      this.selectedPanelId = j;
    },
    onNextClicked: function (idx) {
      debugger;
      if (idx === 0) {
        document
          .getElementById('beginGeneralInstructionsContent')
          .scrollIntoView();
        this.hasWhatsNewBeenViewed = true;
        this.isWhatsNewExpanded = false;
        this.isGeneralInstructionsExpanded = true;
      } else {
        document.getElementById('beginSurveyContent').scrollIntoView();
        this.hasGeneralDefinitionsBeenViewed = true;
        this.hasWhatsNewBeenViewed = true;
        this.isGeneralInstructionsExpanded = false;
      }
    },
    // Create an array the length of our items
    // with all values as true
    all () {
      this.panel = [...Array(this.items).keys()].map((k, i) => i);
    },
    // Reset the panel
    none () {
			this.panel = [];
			this.questionPanel = [];
    },
    next (i) {
      var value = i;
      value++;
      this.panel = value;
      if (i !== 4) {
        document.getElementById('scroll').scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        this.hasGeneralDefinitionsBeenViewed = true;
        this.hasWhatsNewBeenViewed = true;
        this.isGeneralInstructionsExpanded = false;
      }
    },
    onNavPanelClicked (q) {
      this.questionPanel.push(q);
      this.selectedPanelId = q;
    },
    onNavPanelClickedEx (evt) {
      this.onNavPanelClicked(evt.idx);
    },
    onUpdateAnswerStatus (status) {
      if (status) {
        const id = Number.parseInt(status.id) - 1;

        this.onNavPanelClicked(id);
        this.status[id.toString()] = status.status;
      }
    },
    isStandardSurvey: function () {
      if (this.surveyType === utilityService.getSurveyTypes().Standard) {
        return true;
      } else if (this.surveyType === utilityService.getSurveyTypes().DOD) {
        return false;
      }
    }
	}
};
</script>

<style>
.survey-container {
  width: 99%;
  background-color: white !important;
}

/* BASE ACCORDION */

.accordion-container {
  /* width: 100%; */
  border: 1px solid #232323;
  background-color: #bfcfeb !important;
  border-radius: 5px;
  background-color: #f5f5f5;
  height: 34px;
}
.accordion-container:hover {
  cursor: pointer;
}
.accordion-container.type-reference {
  background-color: #fce7d8 !important;
}
.accordion-container.type-reference.info0 {
  background-color: #fad3b8 !important;
}
.info-img-whatsnew {
  width: 24px;
  height: 24px;
}
.info-img {
  width: 20px;
  height: 20px;
}
.title {
  font-weight: bold;
  text-align: left;
}
.title > p {
  margin: 0px 0 0 20px;
  float: right;
  text-align: left;
  width: 100%;
  font-size: 16px;
}
.title > span {
  margin: 0px 0 0 20px;
  float: right;
  text-align: left;
  width: 100%;
  font-size: 16px;
}
.accordion-content {
  min-height: 50px;
}
.displayed {
  display: block;
}
.hidden {
  display: none;
}
.nav-menu {
  position:fixed;
  transform: translate(0%, 0%);
  left: 0%;
  width: 5%;
  min-width: 85px; /* smallest width for text to look decent (at min 1024 px width); might be controversial */
  max-width: 85px;
  margin-top: 1%;
  max-height: calc(100% - 100px);
  overflow-y: auto;
}
:target {
  display: block;
  position: relative;
  top: -5em;
  visibility: hidden;
}

/* LEFT SIDE PANEL */
div.scrollactive-item-container a.scrollactive-item {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.scrollactive-item {
  list-style-type: none;
  margin-left: 0px;
  padding-left: 10px;
  width: 100%;
  color: white !important;
  font-weight: normal;
  font-size: 12pt;
  align-items: center;
}
.status-container {
  width: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
button .status-container {
  height: 25px;
  margin-right: 5px;
}
a.scrollactive-item:hover {
  color: #fff;
  text-decoration: none;
  background-color: #1b639b;
}
.active:hover {
  color: white;
  text-decoration: none;
  background-color: #2f76b7;
}
.scrollactive-item-container:hover {
  background-color: #2f76b7;
}
.scrollactive-nav .layout {
  background-color: #0f5182;
  border-bottom: 1px solid #12629e;
}
.scrollactive-item-container.active {
  background-color: #5b9bd5;
}

.left-aligned {
 text-align: left;
}
.section-reference {
   text-align: left;
}
.section-reference:hover {
    background-color: #2f76b7;
}
.section-reference .scrollactive-item {
  font-size: 9pt;
  font-style: italic;
  width: 100%;
  text-align: center;
  padding-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.content-header {
    font-size: 11px;
    background-color: black;
    color: white;
    padding-top: 1px;
    padding-bottom: 1px;
}
.status-img {
  width: 22px;
  height: 24px;
}
.green {
    color: green !important;
    background-color: white !important;
}
.status-icon.active.green {
  color: green !important;
  background-color: white !important;
}
.orange {
  color: orangered;
}
.v-item-group {
  width: 99%;  /* TODO: Not best way to do this.  Discuss w Dave. */
}

.group-header {
  font-size: 11pt;
  color: dimgray;
  font-weight: bold;
}

.v-expansion-panel-header--active {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-bottom: none !important;
}

.v-expansion-panel--disabled .v-expansion-panel-header__icon,
.v-expansion-panel--disabled .v-expansion-panel-header__icon.i {
  display: hide !important;
}

.impersonation-banner {
  margin-top: -8px; /* WIP: removing <br/>s put on NavBarSurvey to create space above accorditions -- should be reworked */
  padding-left: 15px;
  padding-right: 30px;
}

@media (max-height: 700px) {

  /* on shorter monitors when nav bar will have scrollbar,  navigation bar monitors */
  .section-reference .scrollactive-item {
    font-size: 8pt;
    padding-left: 5px;
    padding-right: 1px;
  }

}
.width {
  width:inherit;
}
html {
  width: inherit !important;
  overflow: auto !important;
}
</style>
